var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nl2br", {
    attrs: {
      tag: "div",
      text: Array.isArray(_vm.value) ? _vm.value.join("、") : _vm.value
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }